<template>
    <button class="btn btn-edit  m-1" @click.prevent="eventHandle(page)">
        <font-awesome-icon icon="fa-edit" size="lg" class="link-icon" />
    </button>
</template>

<script setup>
import { defineEmits } from 'vue';

const emits = defineEmits(['edit']);
const eventHandle = () => {
    emits('edit');
};
</script>